import React, { useState } from 'react';
import { Box, Button, Menu, MenuItem } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { colors, typography } from '../../../styles/theme';
import {
  DEFAULT_LIST_SORT,
  LIST_SORT_OPTIONS,
  getListSortLabel,
} from '../../utils/listSort';

const triggerSx = {
  textTransform: 'none',
  color: colors.textSecondary,
  fontSize: '12px',
  fontWeight: 400,
  minHeight: 24,
  px: 0.5,
  fontFamily: typography.fontFamily.primary,
  '&:hover': { bgcolor: 'rgba(255,255,255,0.04)', color: colors.textPanelTitle },
  '& .MuiButton-endIcon': { ml: 0.25 },
};

/** Igual al botón de orden de Registros. */
const registrosTriggerSx = {
  ...triggerSx,
  // Nunca en dos líneas: el que cede es el label de totales (…).
  flexShrink: 0,
  whiteSpace: 'nowrap',
  color: '#ababab',
  '&:hover': { bgcolor: 'rgba(255,255,255,0.04)', color: '#e5e7eb' },
};

const menuPaperSx = {
  bgcolor: colors.backgroundDark,
  border: `1px solid ${colors.border}`,
  borderRadius: '8px',
  backgroundImage: 'none',
  minWidth: 200,
};

const menuItemSx = {
  color: colors.textPrimary,
  fontSize: '13px',
  fontFamily: typography.fontFamily.primary,
  '&:hover': { bgcolor: 'rgba(255,255,255,0.08)' },
  '&.Mui-selected': { bgcolor: 'rgba(255,255,255,0.10)' },
  '&.Mui-selected:hover': { bgcolor: 'rgba(255,255,255,0.14)' },
};

/**
 * Menú compacto "Ordenar · …" para listados compartidos.
 */
export default function ListSortMenu({
  value = DEFAULT_LIST_SORT,
  onChange,
  options = LIST_SORT_OPTIONS,
  accentColor = null,
  /** «Ordenar por: …» con el estilo del orden de Registros (detalle de lista gestionada). */
  registrosStyle = false,
}) {
  const [anchor, setAnchor] = useState(null);
  const label = options.find((option) => option.value === value)?.label || getListSortLabel(value);
  const selectedColor = registrosStyle ? '#e5e7eb' : (accentColor || colors.textPanelTitle);

  return (
    <>
      <Button
        size="small"
        onClick={(event) => setAnchor(event.currentTarget)}
        endIcon={<ExpandMoreIcon sx={{ fontSize: '16px !important' }} />}
        aria-label="Ordenar lotes"
        aria-haspopup="menu"
        aria-expanded={Boolean(anchor)}
        sx={registrosStyle ? registrosTriggerSx : triggerSx}
      >
        {registrosStyle ? 'Ordenar por:' : 'Ordenar'}
        {' '}
        <Box
          component="span"
          sx={{ color: selectedColor, fontWeight: 500, ml: 0.5 }}
        >
          {label}
        </Box>
      </Button>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ sx: menuPaperSx }}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value}
            selected={value === option.value}
            onClick={() => {
              onChange?.(option.value);
              setAnchor(null);
            }}
            sx={menuItemSx}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
